const API_URL = process.env.API_URL;

const VACATIONS_ABSENCES_ROOT = 'vacations-absences';
const VACATIONS_ABSENCES_URLS = {
  EMPLOYEE_ROOT: VACATIONS_ABSENCES_ROOT + '/employee',
  MANAGER_ROOT: VACATIONS_ABSENCES_ROOT + '/manager',
};

const LOANS_URLS = {
  ROOT: 'loans',
  CREDITWORTHINESS_ROOT: 'creditworthiness',
  MODALITIES_ROOT: 'modalities',
  SIGN_UP_ROOT: 'signup',
  MY_LOANS_ROOT: 'list',
  REPAYMENT_ROOT: 'amortizations',
  SIMULATION_ROOT: 'simulate',
  CADASTRAL_REFERENCE: 'cadastral-references',
  FAMILIES: 'families-purposes',
  EURIBOR: 'euribor',
  WAGE_ADVANCE_REASONS_LIST: 'wages-advance/reasons-list',
  WAGE_ADVANCE_EMPLOYEE: 'wages-advance',
  SERVICE_CLOSED: 'service-and-payroll-closure-date',
  SIGN_UP: 'signup',
  FIXED_SV: 'interest-fixed-sv',
  FIXED_VC: 'interest-fixed-vc',
};

const FOOD_BENEFIT_ROOT = 'food-benefit';
const FOOD_BENEFIT_URLS = {
  EMPLOYEE_ROOT: FOOD_BENEFIT_ROOT + '/employee',
  MANAGER_ROOT: FOOD_BENEFIT_ROOT + '/manager',
};

const DELEGATIONS_ROOT = 'delegations';
const DELEGATIONS_URLS = {
  ROOT: DELEGATIONS_ROOT,
  DELEGABLE_EMPLOYEES: DELEGATIONS_ROOT + '/load-delegable-employees',
};

const MANAGER_FOR_EMPLOYEE_ROOT_URL = 'users';
const MANAGER_FOR_EMPLOYEE_URL = {
  ROOT_MANAGER_FOR_EMPLOYEE: MANAGER_FOR_EMPLOYEE_ROOT_URL + '/obtain-manager-for-employee',
};

const SOLIDARITY_ROOT = 'euro-solidarity';
const SOLIDARITY_URLS = {
  ROOT: SOLIDARITY_ROOT,
  ONG_LIST: 'ong',
  CONTRIBUTIONS: 'contributions',
};

const SOCIAL_SECURITY_ROOT = 'social-security';
const SOCIAL_SECURITY_URLS = {
  ROOT: SOCIAL_SECURITY_ROOT,
  QUOTE_BASIS_INITIAL: 'quote-basis-initial',
};

const AUTHENTICATION_URL = API_URL + '/login';
const AUTHENTICATION_PORTAL_URL = API_URL + '/login-portal';

const VALIDATION_PORTAL_LOGIN_URL = API_URL + '/login-portal/validation';

export { VACATIONS_ABSENCES_URLS, LOANS_URLS, VALIDATION_PORTAL_LOGIN_URL, FOOD_BENEFIT_URLS, AUTHENTICATION_URL, AUTHENTICATION_PORTAL_URL, MANAGER_FOR_EMPLOYEE_URL, DELEGATIONS_URLS, SOLIDARITY_URLS, SOCIAL_SECURITY_URLS };




// WEBPACK FOOTER //
// ./client/app/common/endpoints/endpoints.constants.js